export default __webpack_public_path__ + "static/media/private.5b2272c2.svg";